import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  // Function to handle page change and scroll to top
  const handlePageChange = (page) => {
    onPageChange(page);
    window.scrollTo({ top: 0, behavior: "smooth" }); // Smooth scroll to top
  };

  // Function to render page numbers with ellipses
  const renderPageNumbers = () => {
    const visiblePages = [];

    if (totalPages <= 4) {
      // If there are 5 or fewer pages, show them all
      return pageNumbers;
    }

    if (currentPage <= 3) {
      visiblePages.push(...pageNumbers.slice(0, 4)); // Show first 5 pages
      visiblePages.push('...');
      visiblePages.push(totalPages);
    } else if (currentPage >= totalPages - 2) {
      visiblePages.push(1);
      visiblePages.push('...');
      visiblePages.push(...pageNumbers.slice(totalPages - 4));
    } else {
      visiblePages.push(1);
      visiblePages.push('...');
      visiblePages.push(currentPage - 1);
      visiblePages.push(currentPage);
      visiblePages.push(currentPage + 1);
      visiblePages.push('...');
      visiblePages.push(totalPages);
    }

    return visiblePages;
  };

  return (
    <div className="flex items-center justify-center mt-5 p-4 space-x-2">
      {/* First Button */}
      <button
        className={`w-10 h-10 flex items-center text-[#16bab1] justify-center rounded-md border ${
          currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"
        }`}
        disabled={currentPage === 1}
        onClick={() => handlePageChange(1)}
      >
        &laquo; {/* First page icon */}
      </button>

      {/* Previous Button */}
      <button
        className={`w-10 h-10 flex items-center justify-center text-[#16bab1]  rounded-md border ${
          currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"
        }`}
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        <FaChevronLeft  className="text-[#16bab1]"/>
      </button>

      {/* Page Numbers */}
      {renderPageNumbers().map((page, index) => (
        <button
          key={index}
          className={`w-10 h-10 flex items-center justify-center rounded-md border text-lg font-semibold transition-all ${
            page === currentPage ? "bg-[#16bab1] text-white" :   "  text-[#16bab1]"
          }`}
          onClick={() => {
            if (page !== '...') handlePageChange(page);
          }}
          disabled={page === '...'}
        >
          {page === '...' ? '...' : page}
        </button>
      ))}

      {/* Next Button */}
      <button
        className={`w-10 h-10 flex items-center justify-center rounded-md border ${
          currentPage === totalPages ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"
        }`}
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        <FaChevronRight className="text-[#16bab1]" />
      </button>

      {/* Last Button */}
      <button
        className={`w-10 h-10 flex items-center justify-center text-[#16bab1]  rounded-md border ${
          currentPage === totalPages ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"
        }`}
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(totalPages)}

      >
        &raquo; {/* Last page icon */} 
      </button>
    </div>
  );
};

export default Pagination;
